import { render, staticRenderFns } from "./ShareholdersCommunication.vue?vue&type=template&id=9affd592&"
import script from "./ShareholdersCommunication.vue?vue&type=script&lang=js&"
export * from "./ShareholdersCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports